/**
 * Utility functions for working with forum categories
 */

/**
 * Formats a category name for display by appending " Forum" if not already present
 * @param categoryName - The raw category name from the database
 * @returns The formatted display name with " Forum" appended
 */
export const formatCategoryDisplayName = (categoryName: string): string => {
  if (!categoryName) return '';
  
  // Skip if already ends with "Forum" (case-insensitive)
  if (categoryName.toLowerCase().endsWith('forum')) {
    return categoryName;
  }
  
  return `${categoryName} Youth Soccer Forum`;
};
